import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import DialogTitle from "@material-ui/core/DialogTitle";
import {makeStyles} from "@material-ui/styles";
import RenderComponents from "../../../../../Components/JsonScreen/Screen/ScreenComponents/RenderComponents";
import Divider from "@material-ui/core/Divider";
import {generatingDefaultFields} from "../../../../../Components/JsonScreen/Utils";
import {useSelector} from "react-redux";
import {multiLanguageValue} from "../../../../../Components/JsonScreen/Utils/lib";

const useStyles = makeStyles(() => ({
    dialogTitle: {
        padding: 5
    },
    dialogActions: {
        padding: 5
    },
    container: {
        padding: '10px 15px 10px 10px'
    }
}));


const CreateValuePopup = (props) => {
    const {onApply, open, onClose, field, children = []} = props;
    const [defaultFields, setDefaultFields] = useState([]);
    const classes = useStyles();
    const {userLanguage} = useSelector(state => state.app);

    useEffect(() => {
        if (open) {
            let schema = [];
            let fieldSchema = field.schema ? JSON.parse(JSON.stringify(field.schema.properties)) : [];
            generatingDefaultFields(
                fieldSchema,
                schema,
                '',
                0,
                field.schema ? field.schema.id : "",
                true,
                fieldSchema,
            );
            setDefaultFields(schema);
        }

    }, [open]);

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle classes={{root: classes.dialogTitle}}>
                {multiLanguageValue(field.label, userLanguage)}
            </DialogTitle>
            <Divider/>
            <div className={classes.container}>
                {
                    defaultFields.map(item => (
                        <RenderComponents
                            element={{
                                ...item,
                                properties: {
                                    ...item.properties,
                                    path: `entityMixedCreation.${item.properties.path}`
                                }
                            }}
                            isTableCell={false}
                        />
                    ))
                }
            </div>
            <Divider/>
            <DialogActions>
                <Button color={"default"} variant={"contained"} size={"small"} onClick={onClose}>
                    Cancel
                </Button>
                <Button color={"primary"} variant={"contained"} size={"small"} onClick={onApply}>
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    )
};

export default CreateValuePopup

CreateValuePopup.propTypes = {
    field: PropTypes.object,
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onApply: PropTypes.func.isRequired
};